import React, { Component } from 'react';
import Bookaccordian from './../components/Bookaccordian';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';

const $=window.$;
const win=window; 

class MyDiary extends Component {
	constructor(props) {
		super(props);

        this.state={
					lrwise:[],
					dlrwise:[],
					modulewise:[],
					bookBlock:<Bookaccordian key={`0_initial`} shows={[]}/>
				};

	}
	fnShowid(e){
		let learnerID = Common.getUserData("id", true);
		let pinNo = Common.getUserData("pinNo", true);
		let pinID = Common.getUserData("pinID", true);
		let corporateID = Common.getUserData("corporateID", true);
		let productID = Common.getUserData("productID", true);
		let specialExpiryDate = Common.getUserData("specialExpiryDate", true);
		Common.reactLoader("show", "Please wait...");
		fetch(Config.domainUrl+'learning/mydiary', {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization':'Bearer ' +Common.getTokenData()
				},
					body: JSON.stringify({
						showid:e,
						learnerID:learnerID,
						pinNo:pinNo,
						pinID:pinID,
						corporateID:corporateID,
						productID:productID
					})
				}).then((response) => response.json())
				.then((responseJson) => {
				if(responseJson.status != 0){	 
					 let shows=(responseJson.mydiary.shows!=undefined) ? responseJson.mydiary.shows : [];

				 this.setState({
					  mydiary: responseJson.mydiary,
					 	bookBlock:<Bookaccordian key={`${e}_mydiary`} shows={shows}/>
				 });

				}

						Common.reactLoader("hide");
						Common.downTabClose();
				});
		}
	getTabs(){
		$(".accordion_coach1").smk_Accordion();
		$("#tblleftcontents").click(function(){
			$('.acc-menu-pop').show();
		});
		$(".icon-pop-close").click(function(){
			$('.acc-menu-pop').hide();
		});

	           $('#parentHorizontalTab').easyResponsiveTabs({
	                type: 'default', //Types: default, vertical, accordion
	                width: 'auto', //auto or any width like 600px
	                fit: true, // 100% fit in a container
	                //closed: 'accordion', // Start closed if in accordion view
	                tabidentify: 'hor_1', // The tab groups identifier
	                activate: function (event) { // Callback function if tab is switched

	                    var $tab = $(this);
	                    var $info = $('#nested-tabInfo');
	                    var $name = $('span', $info);

	                    $name.text($tab.text());

	                    $info.show();
	                }
	            });
							$('#ChildVerticalTab_1').easyResponsiveTabs({
			            type: 'vertical',
			            width: 'auto',
			            fit: true,
			            tabidentify: 'ver_1', // The tab groups identifier
			            //resp-tab-active
			           /* activate: function (event) { // Callback function if tab is switched
			                alert('sdf');
			               $('[aria-controls="ver_1_tab_item-2"]').click();
			               alert('dd');
			            } */
			        });



    }
	getDiary(){
			let learnerID = Common.getUserData("id", true);
			let pinNo = Common.getUserData("pinNo", true);
			let pinID = Common.getUserData("pinID", true);
			let corporateID = Common.getUserData("corporateID", true);
			let productID = Common.getUserData("productID", true);
			let specialExpiryDate = Common.getUserData("specialExpiryDate", true);

			Common.reactLoader("show", "Please wait...");
    	fetch(Config.domainUrl+'learning/mydiary', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
				  'Authorization':'Bearer ' +Common.getTokenData()
                },
                  body: JSON.stringify({
                    learnerID:learnerID,
										pinNo:pinNo,
										pinID:pinID,
										corporateID:corporateID,
										productID:productID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	if(responseJson.status != 0){
								 let lrwise=(responseJson.mydiary.lrwise!=undefined) ? responseJson.mydiary.lrwise : '';
								 let dlrwise=(responseJson.mydiary.dlrwise!=undefined) ? responseJson.mydiary.dlrwise : '';
								 let modulewise=(responseJson.mydiary.modulewise!=undefined) ? responseJson.mydiary.modulewise : '';
								  let shows=(responseJson.mydiary.shows!=undefined) ? responseJson.mydiary.shows : [];
								 this.setState({
                     mydiary: responseJson.mydiary,
                     lrwise:lrwise,
										 dlrwise:dlrwise,
										 modulewise:modulewise,
										 bookBlock:<Bookaccordian key={`1_mydiary`} shows={shows}/>
                 });
                }
										Common.reactLoader("hide");
										Common.downTabClose();

   		 			});
    }

	componentDidMount() {
		setTimeout(()=>{
				this.getTabs();
				this.getDiary();
				//Common.showSmallLeftMenu();
		},500)
	}

	getLrinfo(type,lr_id,dlr_id){
		this.props.switchPanel(type,lr_id,dlr_id);
	}

		render() {
				let lrwise_list = null;
      	if(this.state.lrwise!=null || this.state.lrwise!=undefined) {
				lrwise_list= this.state.lrwise.map((key,index)=>{
												return <div key={`lrwise${index}`}> <li key={`li-lrwise${index}`}> <a key={`alrwise${index}`} onClick={(e) =>this.fnShowid(key['show_id'])} className="lr_name" id=""  >{key['lrwise_name']}</a> </li></div>
								});
		}

		let dlrwise_list = null;
      	if(this.state.dlrwise!=null || this.state.dlrwise!=undefined) {
				dlrwise_list=this.state.dlrwise.map((key,index)=>{
													return <div key={`dlrwise${index}`}> <li key={`li-dlrwise${index}`}> <a key={`adlrwise${index}`} onClick={(e) =>this.fnShowid(key['show_id'])} className="dlr_name" id=""  >{key['main_title']}</a> </li></div>
				});
		}

		let modulewise_list = null;
      	if(this.state.modulewise!=null || this.state.modulewise!=undefined) {

			 modulewise_list=this.state.modulewise.map((key,index)=>{
													return <div key={`m-wise${index}`}> <li key={`li-mlrwise${index}`}> <a key={`a-mwise${index}`} onClick={(e) =>this.fnShowid('mwise_'+key['show_id'])} className="module_name" id=""  >{key['module_name']}</a> </li></div>
				});
		}


		return (

		 <section id="contentsection" className="contentarea" style={{width:'92.2%'}} >

			 <div className="inner-title-bg journey-tit-bg">
				 <h1><span><img src={process.env.PUBLIC_URL+'/images/seekfdback.jpg'} align="absmiddle" alt="" border="0" /></span>My Diary<br />
					 <span className="subtitle">My Diary</span></h1>
			 </div>
			 <div className="main-inner">

				 <div className="border-box">

					 <form name="diary_form" id="diary_form" action="" method="post" >
						 <section id="semana-scroll-inner" className="scroll">

							 <section className="viewport">
								 <section className="overview">
									 <div className="inner-content">

										 <div className="acc-menu-pop" > <a className="icon-pop-close" href="#"><img src={process.env.PUBLIC_URL+'/images/close-icon.png'} align="absmiddle" alt="" border="0" /></a>
											 <div className="accordion_coach1">

												 <div id="lrwisediv"  className="accordion_in acc_active" >
													 <div className="acc_head">LR Wise</div>

													 <div className="acc_content" >
														 <ul className="pop-menu-list">
														 		{lrwise_list}
														 </ul>
													 </div>
												 </div>

												 <div id="dlrwisediv" className="accordion_in ">
													 <div className="acc_head">DLR Wise</div>
													 <div className="acc_content" >
														 <ul className="pop-menu-list">
														 {dlrwise_list}
														 </ul>
													 </div> 
												 </div>

												 <div id="modulewisediv" className="accordion_in  last">
													 <div className="acc_head">Module Wise</div>
													 <div className="acc_content" >
														 <ul className="pop-menu-list module_name_wise">
															{modulewise_list}
														 </ul>
													 </div>
												 </div>
											 </div>
										 </div>

											{this.state.bookBlock}


									 </div>

								 </section>
							 </section>
						 </section>

					 </form>
				 </div>
			 </div>

		 </section>
			);

		}
}
export default MyDiary;



// WEBPACK FOOTER //
// ./src/learning_records/MyDiary.js